import React, { Component } from "react";
import { labels } from "../../../../src/localization/labels";
import { constants } from "../../../utils/Constants";
import ContextMenu from "../../domain/page/ContextMenu";
import SubmitButton from "./SubmitButton";

class SubmitButtonContainer extends Component {
  constructor(props) {
    super(props);
    this.state = this.initialState();
    this.contextMenuRef = React.createRef();
  }

  initialState() {
    var contextMenuItems = [];
    if (this.props.type === "link") {
      if (!this.props.openInNewTab) {
        throw new Error(
          "SubmitButton of type 'link' must implement 'opnInNewTab' function"
        );
      }
      contextMenuItems.push({
        label: labels.newTab,
        callback: this.props.openInNewTab,
        menuItemType: constants.MENU_ITEM_TYPE_NEW_TAB
      });
    }
    contextMenuItems = contextMenuItems.concat(
      this.props.additionalContextMenuItems || []
    );
    return {
      contextMenuItems
    };
  }

  getOpenInNewTab() {
    var returnMenuItem;
    const { contextMenuItems } = this.state;
    Object.keys(contextMenuItems).forEach(function (key) {
      const menuItem = contextMenuItems[key];
      if (menuItem.menuItemType === constants.MENU_ITEM_TYPE_NEW_TAB)
        returnMenuItem = menuItem;
    });
    return returnMenuItem;
  }

  onAuxClick = e => {
    e.preventDefault();
    if (e.button === constants.MIDDLE_CLICK) {
      if (this.state.contextMenuItems?.length) {
        const menuItem = this.getOpenInNewTab();
        if (menuItem) {
          menuItem.callback();
        }
      }
    }
    if (e.button === constants.RIGHT_CLICK) {
      if (this.state.contextMenuItems?.length) {
        this.onContextMenu(e);
      }
    }
  };

  onContextMenu = e => {
    e.preventDefault();
    if (this.state.contextMenuItems?.length) {
      if (this.contextMenuRef?.current) {
        this.contextMenuRef.current.setContextMenu(
          this.state.contextMenuItems,
          e
        );
      }
    }
  };

  render() {
    return (
      <>
        <SubmitButton
          onContextMenu={this.onContextMenu}
          onAuxClick={this.onAuxClick}
          {...this.props}
        />
        <ContextMenu ref={this.contextMenuRef} />
      </>
    );
  }
}

export default SubmitButtonContainer;
